import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { IProduct } from '../products.interface';
import { ProductsService } from '../products.service';
import * as _ from 'lodash';
import { ICategory } from '../../../categories-page/categories/categories.interface';
import { Unit } from '../../../../shared/constants/unit.constants';
import { CategoriesService } from '../../../categories-page/categories/categories.service';
import { DialogService } from '../../../../shared/services/dialog/dialog.service';
import { AuthService } from '../../../../shared/services/auth.service';
import { CategoriesModalComponent } from '../../../categories-page/categories/categories-modal/categories-modal.component';

let self: any;

@Component({
  selector: 'app-products-modal',
  templateUrl: './products-modal.component.html',
  styleUrls: ['./products-modal.component.css']
})
export class ProductsModalComponent implements OnInit {
  dialog: MatDialogRef<any>;
  readOnly: boolean = false;
  loading: boolean = false;
  saving: boolean = false;
  product!: IProduct;
  form!: UntypedFormGroup;
  submitted = false;
  categories: ICategory[] = [];
  isDev!: boolean;
  curr!: string;
  unitList: any = Unit;
  unitListKeys = Object.keys(Unit);
  constructor(
    public _ProductsService: ProductsService,
    public _CategoriesService: CategoriesService,
    private _dialogService: DialogService,
    public dialogRef: MatDialogRef<any>,
    private _dialog: MatDialog,
    private _viewContainerRef: ViewContainerRef,
    private fb: UntypedFormBuilder,
    private ref: ChangeDetectorRef,
    private _AuthService: AuthService
  ) {
    self = this;
    this.dialog = dialogRef;
  }

  ngOnInit(): void {
    this.curr = this._AuthService.currency();
    this.isDev = this._AuthService.isRole('dev');
    this.getCategories();
    if (this.product._id) this.getProduct();
    else this.buildForm();
  }

  getCategories() {
    this._CategoriesService.getCategories({
      filters: { isDeleted: false },
      company: this._AuthService.companyId(),
      sort: 'name',
      skip: 0,
      limit: 1000
    }).subscribe((categories) => {
      this.categories = categories;
    });
  }

  getProduct() {
    this.loading = true;
    this._ProductsService.getProduct(this.product._id || '').subscribe((product) => {
      this.product = product;
      this.buildForm();
      this.loading = false;
    });
  }

  get f() { return this.form.controls; }
  buildForm() {
    this.form = this.fb.group({
      name: [this.product.name, [Validators.required]],
      unit: [this.product.unit, [Validators.required]], 
      cost: [this.product.cost, [Validators.compose([Validators.required, Validators.min(0)])]],
      price: [this.product.price, [Validators.compose([Validators.required, Validators.min(0)])]],
      description: [this.product.description],
      category: [_.get(this.product, 'category._id'), [Validators.required]],
      isDeleted: [this.product.isDeleted]
    });
  }

  setEditable(value: boolean = false) {
    this.readOnly = value;
  }

  openNewCategoryModal() {
    this.openCategoryModal({});
  }

  openCategoryModal(category: ICategory, readOnly: boolean = false) {
    let config = new MatDialogConfig();
    // config.disableClose = true;
    config.width = '400px';
    config.maxWidth = '90vw';
    config.viewContainerRef = this._viewContainerRef;
    self.dialogRef = this._dialog.open(CategoriesModalComponent, config);
    self.dialogRef.componentInstance.category = category;
    self.dialogRef.componentInstance.readOnly = readOnly;

    self.dialogRef.afterClosed().subscribe((result: any) => {
      self.dialogRef = null;
      if (result) {
        this.getCategories();
        this.product.category = result._id;
        this.f['category'].setValue(result._id);
      }
    });
  }

  onSubmit() {
    this.submitted = true;
    let data: IProduct = _.cloneDeep(this.form.value);
    if (this.form.invalid) return;
    this.saving = true;
    data.company = this._AuthService.companyId();
    if (this.product._id) {
      data._id = this.product._id;
      this._ProductsService.updateProduct(data).subscribe((product) => {
        this.dialog.close(product);
      });
    } else {
      this._ProductsService.createProduct(data).subscribe((product) => {
        this.dialog.close(product);
      });
    }
  }

  cancelSubmit() {
    if (!this.product._id) return this.dialog.close();
    Object.keys(this.form.controls).forEach((key) => this.form.controls[key].setErrors(null));
    this.setEditable(true);
    this.getProduct();
  }
}